import { NavItem } from './general.known.routes';

/**
 * DON'T EVER CHANGE NUMERATION
 */
export enum IncidentsKnownItemId {
  LIST = 1,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'incidents' } => {
  return {
    ...input,
    type: 'incidents',
  };
};

export const IncidentsKnownRoutes = (k: IncidentsKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};
const options: {
  [k in IncidentsKnownItemId]: NavItem & { type: 'incidents' };
} = {
  [IncidentsKnownItemId.LIST]: simpleTransformer({
    id: IncidentsKnownItemId.LIST,
    displayName: 'Incidentes',
    iconName: 'alert',
    route: '/home/incidents/list',
  }),
};
